module.exports = __webpack_public_path__ + "static/media/refresh.c5277fbe.svg";